/**
 * Settings card: per-platform profile copy behind platform tabs (DD-007).
 * Display only; the copy is edited from the Home panel (DD-043).
 */

import React, { useState } from "react";
import { Client, SocialPlatform } from "@/types";
import { SocialPlatformTabs } from "./SocialPlatformTabs";
import { SocialProfileRows } from "./SocialProfileRows";

export const SocialProfilesSection: React.FC<{ client: Client }> = ({ client }) => {
  const [platform, setPlatform] = useState<SocialPlatform>("instagram");

  return (
    <div>
      <h3 className="text-base font-semibold text-gray-900 mb-4">Social profiles</h3>
      <div className="mb-4">
        <SocialPlatformTabs platform={platform} onChange={setPlatform} />
      </div>
      <SocialProfileRows platform={platform} profile={client.socialProfiles?.[platform]} />
    </div>
  );
};
